import { FETCH_RECALCULATE_HOUR_SUCCESS } from "../Constants";

export default (state = { type: "", message: "" }, action) => {
  switch (action.type) {
    case FETCH_RECALCULATE_HOUR_SUCCESS:
      return {
        type: "Recalculate data Saved Successfully",
        message: action.data
      };

    default:
      return state;
  }
};
